import axios from "axios";
import { serviceUrl } from "../../config";
import { checkSessionIsActive, getSessionData } from "../utilfunctions/utilFunctions";
import { resetSession } from "./sessions";

const BACKEND_URL = serviceUrl;

export const getCustomerAccount = async (userid) => {
  const sessionData = getSessionData();
  // console.log(userid)
  try {
    const data = JSON.stringify({
      svc: "transfers",
      pid: "listConsumerAccounts",
      dat: {
        userid: userid,
        ...sessionData
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }
    // 

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const CRMDepositFunds = async (
  id,
  countryid,
  firstName,
  lastName,
  verifiedtelephoneno,
  userid,
  amount,
  total,
  langID,
  accountID,
  address1,
  address2,
  cityname,
  pin,
  agentID,
  agentFirstName,
  agentLastName,
  agentCity,
  agentCountry,
  parentuserid,
  isOperator
) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "transfers",
      pid: "CRMDepositfunds",
      dat: {
        id: id,
        countryid: countryid,
        firstName: firstName,
        lastName: lastName,
        verifiedtelephoneno: verifiedtelephoneno,
        userid: userid,
        amount: amount,
        total: total,
        langID: langID,
        accountID: accountID,
        address1: address1,
        address2: address2,
        cityname: cityname,
        pin: pin,
        agentID: agentID,
        agentFirstName: agentFirstName,
        agentLastName: agentLastName,
        agentCity: agentCity,
        agentCountry: agentCountry,
        parentuserid: parentuserid,
        isOperator: isOperator,
        ...sessionData
      },
    });

    // console.log(data);

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }


    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getContactList = async (userid) => {
  const sessionData = getSessionData();
  // console.log(userid);
  try {
    const data = JSON.stringify({
      svc: "transfers",
      pid: "ListAssociatedContactsExternal",
      dat: {
        userid: userid,
        ...sessionData
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }


    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const ValidateToken = async (txcode, confirmcode, id, agentID) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "transfers",
      pid: "GetWithdrawalTransaction",
      dat: {
        txcode: txcode,
        confirmcode: confirmcode,
        id: id,
        agentID: agentID,
        ...sessionData
      },
    });

    // console.log(data);

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }


    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const InternalTransfer = async (
  userID,
  langID,
  sourceagentpi,
  sourceagentpiid,
  targetagentpid,
  targetagentpiid,
  countryid,
  firstName,
  lastName,
  currcode,
  sendamount,
  telephoneno,
  agentID,
  agentFirstName,
  agentLastName,
  pin,
  parentuserid
) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "transfers",
      pid: "CustomerInternalTransfer",
      dat: {
        userID: userID,
        langID: langID,
        sourceagentpiid: sourceagentpiid,
        sourceagentpi: sourceagentpi,
        targetagentpi: targetagentpid,
        targetagentpiid: targetagentpiid,
        countryid: countryid,
        firstName: firstName,
        lastName: lastName,
        currcode: currcode,
        sendamount: sendamount,
        telephoneno: telephoneno,
        agentID: agentID,
        agentFirstName: agentFirstName,
        agentLastName: agentLastName,
        pin: pin,
        parentuserid: parentuserid,
        ...sessionData
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    // console.log(data);

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }


    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const transferFromBlockedMC = async (
  userID,
  langID,
  sourceagentpi,
  sourceagentpiid,
  targetagentpid,
  targetagentpiid,
  countryid,
  firstName,
  lastName,
  currcode,
  sendamount,
  telephoneno,
  agentID,
  agentFirstName,
  agentLastName,
  pin,
  parentuserid,
  sourceaccountnumber,
  targetaccountnumber
) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "transfers",
      pid: "transferFromBlockedMC",
      dat: {
        userID: userID,
        langID: langID,
        sourceagentpiid: sourceagentpiid,
        sourceagentpi: sourceagentpi,
        targetagentpi: targetagentpid,
        targetagentpiid: targetagentpiid,
        countryid: countryid,
        firstName: firstName,
        lastName: lastName,
        currcode: currcode,
        sendamount: sendamount,
        telephoneno: telephoneno,
        agentID: agentID,
        agentFirstName: agentFirstName,
        agentLastName: agentLastName,
        pin: pin,
        parentuserid: parentuserid,
        sourceaccountnumber: sourceaccountnumber,
        targetaccountnumber: targetaccountnumber,
        ...sessionData
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    // console.log(data);

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }


    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const saveExternalContact = async (
  address,
  id,
  firstName,
  lastName,
  email,
  phoneno,
  recipientcountry
) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "transfers",
      pid: "ContactAddExternal",
      dat: {
        address: address,
        userid: id,
        firstName: firstName,
        lastName: lastName,
        email: email,
        phoneno: phoneno,
        recipientcountry: recipientcountry,
        ...sessionData
      },
    });

    // console.log(data);

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }


    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const claimTransfer = async (
  brokerid,
  transferUserID,
  privateWWW,
  userID,
  transferID,
  txcode,
  confirmcode,
  sourceNodeID,
  sourceUserID,
  senderFirstName,
  senderLastName,
  name,
  pid,
  piid,
  currcode,
  sourcepi,
  sourcepiid,
  countryid,
  sendamount,
  telephoneno,
  langID,
  pin,
  agentID,
  agentFirstName,
  agentLastName,
  agentCity,
  agentCountry,
  recipientAddress,
  parentuserid,
  isOperator
) => {
  const sessionData = getSessionData();
  // console.log(transferID);
  // console.log(sourcepiid);
  try {
    const data = JSON.stringify({
      svc: "transfers",
      pid: "Deposittoaccount",
      dat: {
        brokerid: brokerid,
        targetUserID: transferUserID,
        privateWWW: privateWWW,
        userID: userID,
        transferID: transferID,
        txcode: txcode,
        confirmcode: confirmcode,
        sourceNodeID: sourceNodeID,
        sourceUserID: sourceUserID,
        senderFirstName: senderFirstName,
        senderLastName: senderLastName,
        recipientname: name,
        pid: pid,
        piid: piid,
        currcode: currcode,
        sourcepi: sourcepi,
        sourcepiid: sourcepiid,
        countryid: countryid,
        sendamount: sendamount,
        telephoneno: telephoneno,
        langID: langID,
        pin: pin,
        agentID: agentID,
        agentFirstName: agentFirstName,
        agentLastName: agentLastName,
        agentCity: agentCity,
        agentCountry: agentCountry,
        recipientAddress: recipientAddress,
        parentuserid: parentuserid,
        isOperator: isOperator,
        ...sessionData
      },
    });

    // console.log(data);

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }


    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getReceipts = async (transgroupid) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "transfers",
      pid: "getReceipts",
      dat: {
        transgroupid: transgroupid,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }


    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const postFees = async (
  userid,
  fromuserid,
  postuseraccid,
  postfeeamount,
  targetaccno,
  postfeepurposetitle,
  firstName,
  lastName,
  senderuserfirstname,
  senderuserlastname,
  accID,
  agentID,
  agentFirstName,
  agentLastName,
  pin,
  parentuserid,
  isOperator
) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "transfers",
      pid: "postfeetouserpi",
      dat: {
        userid: userid,
        fromuserid: fromuserid,
        postuseraccid: postuseraccid,
        postfeeamount: postfeeamount,
        targetaccno: targetaccno,
        postfeepurposetitle: postfeepurposetitle,
        firstName: firstName,
        lastName: lastName,
        senderuserfirstname: senderuserfirstname,
        senderuserlastname: senderuserlastname,
        accID: accID,
        agentID: agentID,
        agentFirstName: agentFirstName,
        agentLastName: agentLastName,
        pin: pin,
        parentuserid: parentuserid,
        isOperator: isOperator,
        ...sessionData
      },
    });

    // console.log(data);

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }


    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getDomain = async (
) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "transfers",
      pid: "getdomains",
      dat: {...sessionData},
    });

    // console.log(data);

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const sendDeposit = async (
  userID,
  currcode,
  sendamount,
  PIN,
  pid,
  piid,
  recipientphone,
  comments,
  recipientname,
  recipientemail,
  sendername,
  senderaddress,
  sendercountry,
  sendercountrydat,
  sendermobile,
  senderemail,
  recipientaddress,
  recipientcountry,
  recipientcountrydat,
  total,
  txdate,
  pin,
  agentID,
  agentFirstName,
  agentLastName,
  parentuserid,
  isOperator
) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "transfers",
      pid: "CustomerCashWithdrawal",
      dat: {
        userID: userID,
        currcode: currcode,
        sendamount: sendamount,
        PIN: PIN,
        pid: pid,
        piid: piid,
        recipientphone: recipientphone,
        comments: comments,
        recipientname: recipientname,
        recipientemail: recipientemail,
        sendername: sendername,
        senderaddress: senderaddress,
        sendercountry: sendercountry,
        sendercountrydat: sendercountrydat,
        sendermobile: sendermobile,
        senderemail: senderemail,
        recipientaddress: recipientaddress,
        recipientcountry: recipientcountry,
        recipientcountrydat: recipientcountrydat,
        total: total,
        txdate: txdate,
        pin: pin,
        agentID: agentID,
        agentFirstName: agentFirstName,
        agentLastName: agentLastName,
        parentuserid: parentuserid,
        isOperator: isOperator,
        ...sessionData
      },
    });


    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getMastercardDetails = async (
  pid,
  kycuser,
  currcode
) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "transfers",
      pid: "getuserpidetails",
      dat: {
        kycuser: kycuser,
        currcode: currcode,
        pid: pid,
        ...sessionData
      },
    });

    // console.log(data);

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }


    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const voucherWithdrawal = async (
  // userID,
  confirmCode,
  tokenID,
  agentID,
  pin,
  agentFirstName,
  agentLastName,
  agentCity,
  agentCountry,
  parentuserid,
  isOperator
) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "transfers",
      pid: "getVoucherWithdrawal",
      dat: {
        // userID: userID,
        voucher: tokenID,
        confirmcode: confirmCode,
        agentID: agentID,
        pin: pin,
        agentFirstName: agentFirstName,
        agentLastName: agentLastName,
        agentCity: agentCity,
        agentCountry: agentCountry,
        parentuserid: parentuserid,
        isOperator: isOperator,
        ...sessionData
      },
    });

    // console.log(data);

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }


    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const verifyCardToken = async (
  userID,
  barcode,
  parentuserid
) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "transfers",
      pid: "RetrievePIwithUBC",
      dat: {
        agentID: userID,
        // userID: userID,
        barcode: barcode,
        parentuserid: parentuserid,
        ...sessionData
      },
    });

    // console.log(data);

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }


    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const sendSMSorEmail = async (
  merchantid,
  recipientemail,
  recipientphone,
  userid,
  country,
  type,
  txcode,
  claimcode,
  senderName
) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "sendSMSorEmail",
      dat: {
        merchantid: merchantid,
        recipientemail: recipientemail,
        recipientphone: recipientphone,
        userid: userid,
        country: country,
        stype: type,
        txcode: txcode,
        claimcode: claimcode,
        sendername: senderName,
        ...sessionData
      },
    });

    // console.log(data);

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }


    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const barcodeWithdrawal = async (
  userID,
  currcode,
  sendamount,
  PIN,
  pid,
  piid,
  recipientphone,
  comments,
  recipientname,
  recipientemail,
  sendername,
  senderaddress,
  sendercountry,
  sendercountrydat,
  sendermobile,
  senderemail,
  recipientaddress,
  recipientcountry,
  recipientcountrydat,
  total,
  txdate,
  pin,
  agentID,
  agentFirstName,
  agentLastName,
  parentuserid,
  isOperator,
  customerpin
) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "transfers",
      pid: "CustomerCashWithdrawal2",
      dat: {
        userID: userID,
        currcode: currcode,
        sendamount: sendamount,
        PIN: PIN,
        pid: pid,
        piid: piid,
        recipientphone: recipientphone,
        comments: comments,
        recipientname: recipientname,
        recipientemail: recipientemail,
        sendername: sendername,
        senderaddress: senderaddress,
        sendercountry: sendercountry,
        sendercountrydat: sendercountrydat,
        sendermobile: sendermobile,
        senderemail: senderemail,
        recipientaddress: recipientaddress,
        recipientcountry: recipientcountry,
        recipientcountrydat: recipientcountrydat,
        total: total,
        txdate: txdate,
        pin: pin,
        agentID: agentID,
        agentFirstName: agentFirstName,
        agentLastName: agentLastName,
        parentuserid: parentuserid,
        isOperator: isOperator,
        customerpin:customerpin,
        ...sessionData
      },
    });

    // console.log(data);

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }


    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const DepositQRCodeConfirm = async (
  qrcode
) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "transfers",
      pid: "GetCustomerWithQR",
      dat: {
        qrcode: qrcode,
        ...sessionData
      },
    });

    // console.log(data);

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }


    return response.data;
  } catch (error) {
    console.log(error);
  }
};